import React from 'react';

interface Props {
  style?: React.CSSProperties;
  classNames?: React.SVGAttributes<SVGSVGElement>['className'];
}
function InfoIcon({ style, classNames }: Props) {
  return (
    <svg
      className={classNames}
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="23"
      viewBox="0 0 22 23"
      style={style}
      fill="none">
      <path
        d="M11 0.332031C4.95 0.332031 0 5.28203 0 11.332C0 17.382 4.95 22.332 11 22.332C17.05 22.332 22 17.382 22 11.332C22 5.28203 17.05 0.332031 11 0.332031ZM11.55 4.2606C12.4143 4.2606 13.2 4.96775 13.2 5.9106C13.2 6.85346 12.4929 7.5606 11.55 7.5606C10.6857 7.5606 9.9 6.85346 9.9 5.9106C9.9 4.96775 10.6071 4.2606 11.55 4.2606ZM10.6857 19.1106C9.27143 19.1106 8.25 17.7749 8.64286 16.4392L10.0571 11.7249C10.2143 11.1749 9.82143 10.7035 9.27143 10.7035H8.56429C8.95714 9.52489 10.0571 8.73917 11.3143 8.73917C12.7286 8.73917 13.75 10.0749 13.3571 11.4106L11.9429 16.1249C11.7857 16.6749 12.1786 17.1463 12.7286 17.1463H13.4357C13.0429 18.3249 11.9429 19.1106 10.6857 19.1106Z"
        fill="#17385D"
      />
    </svg>
  );
}

export default InfoIcon;
